import React, { Fragment } from 'react';
import {
  Button, Card, CardBody,
  Form, FormGroup, Input, Col, Row, Spinner, CardText
} from 'reactstrap';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import BootstrapTable from 'react-bootstrap-table-next';
import { toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';

import PageTitle from '../../Layout/Components/PageTitle';
import ConfirmAction from '../../Layout/Components/ConfirmAction';

import {
  getDomains, createDomain, deleteDomain
} from '../../API/DomainsAPI';

class Domains extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      domains: [],
      domainregistered: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
  }

  componentDidMount() {
    this.fillTable();
  }

  fillTable() {
    getDomains().then(result => {
      this.setState({
        domains: result,
        domainregistered: ""
      });
    }).catch(error => {
      console.error("Error getting Domains", error);
      toast["error"](this.props.t('errors.loading', { element: 'Domains', message: error.message }));
    });
  }

  handleChange(event) {
    const key = event.target.name;
    const value = event.target.value;
    this.setState({
      [key]: value
    });
  }

  add() {
    if (this.state.domainregistered) {
      createDomain(this.state.domainregistered).then(result => {
        toast["success"](this.props.t('messages.success_update', { element: 'domain' }));
        this.fillTable();
      }).catch(error => {
        console.error("Error creating Domains", error);
        toast["error"](this.props.t('errors.creating', { element: 'domain', message: error.message }));
      });
    } else {
      toast["warning"](this.props.t('messages.unable_to_create', {
        element: 'domain',
        message: this.props.t('messages.empty_field', { field: "domain" })
      }));
    }
  }

  delete(domain_id) {
    deleteDomain(domain_id).then(result => {
      toast["success"](this.props.t('messages.success_delete', { element: 'domain' }));
      this.fillTable()
    }).catch(error => {
      console.error("Error deleting Domains", error);
      toast["error"](this.props.t('errors.deleting', { element: 'domain', message: error.message }));
    });
  }

  render() {
    const { t, i18n } = this.props;

    return (
      <Fragment>
        <PageTitle
          heading={t("domains.title")}
          icon="pe-7s-shield icon-gradient bg-primary"
        />
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}>
          <Row>
            <Col md="12" lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                <CardText>{t("domains.text")}</CardText>
                  <Form onSubmit={(e) => { e.preventDefault(); this.add(); }}>
                    <Row form>
                      <Col md={4}>
                        <FormGroup>
                          <Input type="text" name="domainregistered" id="domainregistered"
                            value={this.state.domainregistered} onChange={this.handleChange}
                            placeholder={t("domains.url_placeholder")} />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <Button color="success" className="mb-2 mr-2 btn-icon btn-shadow" onClick={() => this.add()}>
                          <i className="lnr-plus-circle btn-icon-wrapper"> </i>
                          {t("domains.actions.add")}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                  <BootstrapTable
                    bootstrap4
                    keyField="id"
                    data={this.state.domains}
                    columns={[
                      {
                        dataField: 'domainregistered',
                        text: t("domains.domain")
                      },
                      {
                        dataField: 'id',
                        text: t("domains.actions.title"),
                        isDummyField: true,
                        formatter: (cell, row, index) => {
                          return (
                            <div>
                              <div className="d-block w-100 text-center">
                                <ConfirmAction btnClassName="mb-2 mr-2" color="danger" title={t('actions.confirmation')}
                                  message={t('messages.confirm_delete', { element: 'domain', object: row.domainregistered })}
                                  onConfirm={() => this.delete(row.id)}>{t("domains.actions.delete")}</ConfirmAction>
                              </div>
                            </div>
                          );
                        }
                      }
                    ]} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CSSTransitionGroup>
      </Fragment>
    );
  }
}

export default withTranslation()(Domains);